import script from "./CargaTramite.vue?vue&type=script&setup=true&lang=js"
export * from "./CargaTramite.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__